export default __webpack_public_path__ + "static/media/instagram.67413e9a.svg";